/**
 * Requestors page
 *
 * created by Ty D'Angelo 10/17/2022
 */

import * as React from "react";
import { useState, useEffect } from "react";
import { getCookie } from "../utils/cookies";
import axios from "axios";
import ViewRequesters from "../requesters/view/ViewRequesters";
import { CenteredContainer } from "../ui/BaseComponents";

export default function Requestors() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const JWT = await getCookie("ea1-auth");
      const { data } = await axios(
        "https://ea1-dev.azurewebsites.net/api/userServiceRequesterDetail",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: JWT,
          },
        }
      );
      setData(data);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      alert("error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CenteredContainer>
      <ViewRequesters data={data} isLoading={isLoading} />
    </CenteredContainer>
  );
}
